import MuiBackdrop, { type BackdropProps } from "@mui/material/Backdrop";

export type { BackdropProps };

export function Backdrop(props: BackdropProps) {
  return <MuiBackdrop {...props} />;
}
